// extracted by mini-css-extract-plugin
module.exports = {"v-icon":"NsAddressRu_v-icon_1fkJY","nsAddressForm":"NsAddressRu_nsAddressForm_ORbbI","dualColumn":"NsAddressRu_dualColumn_3Ekph","firstCol":"NsAddressRu_firstCol_32O2l"};